<template>
	<div class="component-upload-image">
		<el-upload :class="{hide: this.fileList.length >= this.limit||isUpload}" name="file" :headers="headers"
			:action="uploadUrl" :show-file-list="true" :file-list="fileList" :limit="limit" :on-exceed="handleExceed"
			:on-success="handleUploadSuccess" :on-change="handleChange" :on-error="handleUploadError" :before-upload="handleBeforeUpload"
			 :disabled = "isUpload" :on-preview="handlePictureCardPreview"
			>
			<el-button size="small" :type="isUpload?'info':'primary'">点击上传</el-button> <span class="text-red">建议上传pdf、png、jpg、jpeg文件</span>
			<div slot="file" slot-scope="{file}">
				<ul class="el-upload-list el-upload-list--text">
					<li class="el-upload-list__item is-success">
						<a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{file.name}}</a>
						<label class="el-upload-list__item-status-label"><i
								:class="['',file.status=='success'?'el-icon-upload-success el-icon-circle-check':'el-icon-loading']"></i></label>
						<i class="el-icon-close" @click="handleRemove(file)"></i>
						<i class="el-icon-download"
							style="color: #1890FF; position: absolute; left: calc(100% + 10px); top: 5px; width: 70px; cursor: pointer;"
							@click="downloadFileTxt(file)">下载</i>
						<!-- <i class="el-icon-close-tip">按 delete 键可删除</i> -->
					</li>
				</ul>
			</div>
		</el-upload>

		<!-- 上传提示 -->
		<!-- <div class="el-upload__tip" slot="tip" v-if="showTip">
			请上传
			<template v-if="imgSize"> 尺寸为 <b style="color: #f56c6c">{{ imgSize }},</b> </template>
			<template v-if="fileSize"> 大小不超过 <b style="color: #f56c6c">{{ fileSize }}MB</b> </template>
			<template v-if="fileType"> 格式为 <b style="color: #f56c6c">{{ fileType.join("/") }}</b> </template>
			的图片
		</div> -->

		<el-dialog :visible.sync="dialogVisible" title="预览" width="800" append-to-body>
			<img :src="dialogImageUrl" style="display: block; max-width: 100%; margin: 0 auto" />
		</el-dialog>
	</div>
</template>

<script>
	import {
		getToken
	} from "@/utils/auth";

	export default {
		props: {
			value: [String, Object, Array],
			// 图片数量限制
			limit: {
				type: Number,
				default: 30,
			},
			//图片尺寸
			imgSize: {
				type: String,
				default: "300*300",
			},
			// 大小限制(MB)
			fileSize: {
				type: Number,
				default: 10,
			},
			// 文件类型, 例如['png', 'jpg', 'jpeg']
			fileType: {
				type: Array,
				default: () => ["png", "jpg", "jpeg","pdf"],
			},
			// 是否显示提示
			isShowTip: {
				type: Boolean,
				default: true
			},
			//是否禁止上传
			isUpload: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				number: 0,
				uploadList: [],
				dialogImageUrl: "",
				dialogVisible: false,
				hideUpload: false,
				baseUrl: '',
				// uploadImgUrl: process.env.VUE_APP_BASE_API + "/common/newUpload", // 上传的图片服务器地址
				headers: {
					AdminAuthorization: "Bearer " + getToken(),
				},
				fileList: []
			};
		},
		watch: {
			value: {
				handler(val) {
					if (val) {
						// 首先将值转为数组
						const list = Array.isArray(val) ? val : this.value.split(',');
						// 然后将数组转为对象数组
						this.fileList = list.map((item,index) => {
							if (typeof item === "string") {
								if (item.indexOf(this.baseUrl) === -1) {
									item = {
										name: '文件'+(index+1),
										url: this.baseUrl + item
									};
								} else {
									item = {
										name: '文件'+(index+1),
										url: item
									};
								}
							}
							return item;
						});
					} else {
						this.fileList = [];
						return [];
					}
				},
				deep: true,
				immediate: true
			}
		},
		computed: {
			// 是否显示提示
			showTip() {
				return this.isShowTip && (this.fileType || this.fileSize);
			},
		},
		methods: {
			// 删除图片
			handleRemove(file, fileList) {
				const findex = this.fileList.map(f => f.name).indexOf(file.name);
				if (findex > -1) {
					this.fileList.splice(findex, 1);
					this.$emit("input", this.listToString(this.fileList));
				}
			},
			// 上传成功回调
			handleUploadSuccess(res,file, fileList) {
				// console.log(res,'55',file, fileList,)
				fileList.forEach((itm,index)=>{
					itm.name='文件'+(index+1)
					itm.url= itm.url?itm.url:itm.response.url
				});
				this.fileList = fileList;
				this.$emit("input", this.listToString(this.fileList));
				// console.log(this.fileList,'5566',)
				// this.uploadList.push({
				// 	name: file.name,
				// 	url: res.url
				// });
				// if (this.uploadList.length === this.number) {
				// 	let list = this.fileList.concat(this.uploadList);
				// 	// this.fileList = this.fileList.concat(this.uploadList);
				// 	list.forEach((itm,index)=>{
				// 		itm.name='文件'+(index+1)
				// 	});
				// 	this.fileList = list
				// 	this.uploadList = [];
				// 	this.number = 0;
				// 	this.$emit("input", this.listToString(this.fileList));
				// 	// this.$modal.closeLoading();
				// }
			},
			/** 上传文件 */
			handleChange(file, fileList,e) {
				// console.log('执行',file,FileList,e);
				// fileList.forEach((itm,index)=>{
				// 	itm.name='文件'+(index+1)
				// });
				// this.form.personnelInsurance = fileList;
			},
			// 上传前loading加载
			handleBeforeUpload(file) {
				let isImg = false;
				// console.log(this.uploadImgUrl,11)
				if (this.fileType.length) {
					let fileExtension = "";
					if (file.name.lastIndexOf(".") > -1) {
						fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
					}
					isImg = this.fileType.some(type => {
						if (file.type.indexOf(type) > -1) return true;
						if (fileExtension && fileExtension.indexOf(type) > -1) return true;
						return false;
					});
				} else {
					isImg = file.type.indexOf("image") > -1;
				}
				if (!isImg) {
					this.$modal.msgError(`文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`);
					return false;
				}
				if (this.fileSize) {
					const isLt = file.size / 1024 / 1024 < this.fileSize;
					if (!isLt) {
						this.$modal.msgError(`上传头像图片大小不能超过 ${this.fileSize} MB!`);
						return false;
					}
				}
				// this.$modal.loading("正在上传文件，请稍候...");
				this.number++;
			
			},
			// 文件个数超出
			handleExceed() {
				this.$modal.msgError(`上传文件数量不能超过 ${this.limit} 个!`);
			},
			// 上传失败
			handleUploadError() {
				this.$modal.msgError("上传图片失败，请重试");
				this.$modal.closeLoading();
			},
			// 下载文件
			downloadFileTxt(file){
				this.$confirm('确认要下载吗?', '下载', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					return this.downloadFile(file.url)
				}).then(() => {
					this.msgSuccess('下载成功')
				}).catch(function () {})
			},
			// 预览
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 对象转成指定字符串分隔
			listToString(list, separator) {
				let strs = "";
				separator = separator || ",";
				for (let i in list) {
					strs += list[i].url + separator;
					// strs += list[i].url.replace(this.baseUrl, "") + separator;
				}
				return strs != '' ? strs.substr(0, strs.length - 1) : '';
			}
		}
	};
</script>
<style scoped lang="scss">
	// .el-upload--picture-card 控制加号部分
	::v-deep.hide .el-upload--picture-card {
		display: none;
	}

	// 去掉动画效果
	::v-deep .el-list-enter-active,
	::v-deep .el-list-leave-active {
		transition: all 0s;
	}

	::v-deep .el-list-enter,
	.el-list-leave-active {
		opacity: 0;
		transform: translateY(0);
	}
</style>